import { Children, cloneElement, FC, ReactElement } from 'react'
import { useCollabItemContext } from 'components/CollabItem/CollabItem'
import { ControlGroupBox } from './ControlGroupBox'

const ControlGroup: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { isActive, isHighlighted } = useCollabItemContext()
  if (!isActive && !isHighlighted) {
    return null
  }

  /**
   * We are using Children.forEach here to make sure we take into account null
   * children too.
   * Children.toArray removes the null values, whereas Children.forEach doesn't.
   * Because we sometimes return null, we need to make sure we still count the
   * null ones and return the correct index.
   */
  let firstItemIndex: number | undefined
  Children.forEach(children, (child, index) => {
    if (firstItemIndex === undefined && child !== null && child !== undefined) {
      firstItemIndex = index
    }
  })

  return (
    <ControlGroupBox>
      {Children.map(children, (child, index) => {
        if (!child) return
        return cloneElement(child as ReactElement, {
          ...(child as ReactElement).props,
          excludeFromTabOrder: index > (firstItemIndex || 0),
        })
      })}
    </ControlGroupBox>
  )
}

export { ControlGroup }
